export default __webpack_public_path__ + "static/media/ai_color_tracking.c4512cd0.svg";